import { createClient } from "@supabase/supabase-js"

const supabaseUrl ="https://dyuqmgoqgozadkxqnqqq.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR5dXFtZ29xZ296YWRreHFucXFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDczMjI0NTAsImV4cCI6MjA2Mjg5ODQ1MH0.wqCIpm75Sv-vLa72ql90hO5-rd1YCR3oXXdTAR5j1KE";

const supabase = createClient(supabaseUrl, supabaseAnonKey);
export default supabase;